import React, { useState, useEffect } from "react";
import Button from "../../../utils/components/Button";
import Table from "../../../utils/components/Table";
import Breadcrumbs from "../../../utils/components/Breadcrumbs";
import Modal from "../../../utils/components/Modal";
import keepOrganizer from "../../../utils/functions/keepOrganizer";
import LoadingOverlay from "../../../utils/components/LoadingOverlay";

const PriceListPanel = ({
    tournaments,
    priceLists,
    loadPriceList,
    savePriceItem,
    deletePriceItem,
    copyPriceList,
    loadingReva,
    loadingTournaments,
}) => {
    const [showModal, setShowModal] = useState(false);
    const [activeTournamentId, setActiveTournamentId] = useState(null);
    const [copyFromTournamentId, setCopyFromTournamentId] = useState("");

    // Form State
    const [sku, setSku] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState("");
    const [type, setType] = useState("other");

    const [activeTab, setActiveTab] = useState("form");

    const handleSave = () => {
        if (!sku || !description || !price || !activeTournamentId) return;
        savePriceItem({
            external_relationship_id: activeTournamentId,
            sku,
            description,
            price: Number(price),
            type
        });
        resetForm();
    };

    const handleCopy = () => {
        if (!copyFromTournamentId || !activeTournamentId) return;
        copyPriceList(copyFromTournamentId, activeTournamentId);
        resetForm();
    };

    const resetForm = () => {
        setSku("");
        setDescription("");
        setPrice("");
        setType("other");
        setCopyFromTournamentId("");
        setActiveTab("form");
        setShowModal(false);
    };

    const formatCurrency = (value) => {
        return Number(value).toLocaleString("de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const tournamentsWithItems = (tournaments || []).filter(t => (priceLists[t.id] || []).length > 0);
    const tournamentsWithoutItems = (tournaments || []).filter(t => (priceLists[t.id] || []).length === 0);

    const modalBody = () => (
        <div>
            <div className="tabs-container">
                <ul className="nav nav-tabs">
                    <li className={activeTab === "form" ? "active" : ""}><a onClick={() => setActiveTab("form")} style={{ cursor: 'pointer' }}>Nueva Plantilla</a></li>
                    <li className={activeTab === "copy" ? "active" : ""}><a onClick={() => setActiveTab("copy")} style={{ cursor: 'pointer' }}>Copiar de otro torneo</a></li>
                </ul>
                <div className="tab-content m-t-md">
                    <div className={`tab-pane ${activeTab === "form" ? "active" : ""}`}>
                        <div className="form-group">
                            <label>SKU</label>
                            <input type="text" className="form-control" placeholder="ej: INS-2024" value={sku} onChange={(e) => setSku(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Descripción</label>
                            <input type="text" className="form-control" placeholder="ej: Inscripción Apertura" value={description} onChange={(e) => setDescription(e.target.value)} />
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Precio</label>
                                    <input type="number" className="form-control" value={price} onChange={(e) => setPrice(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Tipo</label>
                                    <select className="form-control" value={type} onChange={(e) => setType(e.target.value)}>
                                        <option value="match-fee">Partido</option>
                                        <option value="tournament-entry-fee">Inscripción</option>
                                        <option value="sanction-fee">Sanción</option>
                                        <option value="other">Otro</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <Button
                            className="btn btn-primary btn-block m-t-sm"
                            title="Guardar Plantilla"
                            onClick={handleSave}
                            loading={loadingReva.savePriceItem}
                            style={{ backgroundColor: '#1ab394', border: 'none' }}
                        />
                    </div>
                    <div className={`tab-pane ${activeTab === "copy" ? "active" : ""}`}>
                        <div className="form-group m-t-md">
                            <label>Seleccionar torneo origen</label>
                            <select
                                className="form-control"
                                value={copyFromTournamentId}
                                onChange={(e) => setCopyFromTournamentId(e.target.value)}
                            >
                                <option value="">Selecciona un torneo...</option>
                                {tournamentsWithItems
                                    .filter(t => t.id !== activeTournamentId)
                                    .map(t => (
                                        <option key={t.id} value={t.id}>{t.name} ({priceLists[t.id].length} items)</option>
                                    ))
                                }
                            </select>
                        </div>
                        <p className="text-muted small">Esto copiará todos los items del torneo seleccionado al torneo actual.</p>
                        <Button
                            className="btn btn-primary btn-block m-t-sm"
                            title="Copiar Plantillas"
                            onClick={handleCopy}
                            loading={loadingReva.copyPriceList}
                            disabled={!copyFromTournamentId}
                            style={{ backgroundColor: '#1ab394', border: 'none' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div style={{ backgroundColor: '#f3f3f4', minHeight: '100vh', paddingBottom: '50px' }}>
            <Breadcrumbs
                title="Lista de Precios"
                opts={[
                    { title: "Inicio", path: keepOrganizer("/") },
                    { title: "Panel Financiero", path: keepOrganizer("/financial") },
                    { title: "Lista de Precios", active: true },
                ]}
            />

            <div className="wrapper wrapper-content">
                <LoadingOverlay loading={loadingTournaments.loadAllTournaments || loadingReva.loadPriceList}>
                <div className="row">
                    <div className="col-lg-12">
                        <h3 style={{ fontWeight: 'bold', marginBottom: '20px' }}>Plantillas de Cobro por Torneo</h3>
                    </div>
                </div>

                <div className="row">
                    {tournamentsWithItems.map((tournament) => (
                        <div key={tournament.id} className="col-md-6 m-b-lg">
                            <div className="ibox float-e-margins" style={{ borderRadius: '15px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', border: 'none' }}>
                                <div className="ibox-title" style={{ backgroundColor: '#1ab394', color: 'white', border: 'none', padding: '15px 20px' }}>
                                    <h5 style={{ fontSize: '16px', fontWeight: 'bold' }}>{tournament.name}</h5>
                                    <div className="ibox-tools">
                                        <Button
                                            className="btn btn-primary btn-xs"
                                            title={<i className="fa fa-plus"></i>}
                                            onClick={() => {
                                                setActiveTournamentId(tournament.id);
                                                setShowModal(true);
                                            }}
                                            style={{ backgroundColor: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '4px' }}
                                        />
                                    </div>
                                </div>
                                <div className="ibox-content" style={{ padding: '0' }}>
                                    <table className="table table-hover no-margins">
                                        <thead>
                                            <tr>
                                                <th style={{ paddingLeft: '20px' }}>SKU</th>
                                                <th>Descripción</th>
                                                <th className="text-right">Precio</th>
                                                <th style={{ paddingRight: '20px' }} className="text-right"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(priceLists[tournament.id] || []).map((item) => (
                                                <tr key={item.id} style={{ transition: 'background 0.2s' }}>
                                                    <td style={{ paddingLeft: '20px', verticalAlign: 'middle' }}><span className="label label-default">{item.sku}</span></td>
                                                    <td style={{ verticalAlign: 'middle' }}><strong>{item.name}</strong></td>
                                                    <td style={{ verticalAlign: 'middle' }} className="text-right"><strong>${formatCurrency(item.amount)}</strong></td>
                                                    <td style={{ paddingRight: '20px', verticalAlign: 'middle' }} className="text-right">
                                                        <Button
                                                            className="btn btn-xs btn-white"
                                                            title={<i className="fa fa-trash text-danger"></i>}
                                                            onClick={() => deletePriceItem(item.id)}
                                                            loading={loadingReva.deletePriceItem}
                                                            style={{ border: 'none' }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {tournamentsWithoutItems.length > 0 && (
                    <div className="row m-t-lg">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins" style={{ borderRadius: '15px', overflow: 'hidden', border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                                <div className="ibox-title" style={{ border: 'none' }}>
                                    <h5>Torneos sin plantillas de cobro</h5>
                                </div>
                                <div className="ibox-content">
                                    <Table
                                        loading={loadingTournaments.loadAll}
                                        headers={[
                                            { label: "Nombre del Torneo", ref: "name" },
                                            { label: "Acciones", ref: "actions" },
                                        ]}
                                        rows={tournamentsWithoutItems.map(t => ({
                                            ...t,
                                            actions: (
                                                <Button
                                                    className="btn btn-outline btn-primary btn-xs"
                                                    title="Crear Lista de Precios"
                                                    onClick={() => {
                                                        setActiveTournamentId(t.id);
                                                        setShowModal(true);
                                                    }}
                                                    style={{ borderRadius: '4px' }}
                                                />
                                            )
                                        }))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                </LoadingOverlay>
            </div>

            <Modal
                show={showModal}
                handleShow={setShowModal}
                title={activeTournamentId ? `Gestionar Plantillas - ${tournaments.find(t => t.id === activeTournamentId)?.name}` : "Gestionar Plantillas"}
                body={modalBody()}
                buttons={[
                    <Button
                        key="close"
                        className="btn btn-white"
                        title="Cerrar"
                        onClick={resetForm}
                        style={{ borderRadius: '8px', padding: '8px 20px', fontWeight: 'bold' }}
                    />
                ]}
            />
        </div>
    );
};

export default PriceListPanel;
